import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Globe from 'react-globe.gl';

export default function Home() {
  return (
    <div
      style={{
        minHeight: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundImage: 'url(/earth-topology.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        fontFamily: 'Arial, sans-serif',
        color: 'white',
        margin: 0,
        padding: 0,
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 0,
        boxSizing: 'border-box',
      }}
    >
      <div style={{ fontSize: '1.5rem', padding: '2rem', maxWidth: '900px', width: '100%', background: 'rgba(0,0,0,0.0)', borderRadius: '20px',userSelect: 'none '  }}>
        <br />
        <p>Portfolio - A collection of maps and other gis relative project.</p>
        <br />
        <p>Map - An interactive map.</p>
        <br />
        <p>  Globe - A 3D visualization of the earth with different type of layers.</p>  
        <br />
        <p>Contact - Get in touch for inquiries or collaborations.</p>
        <br />
        <p>About - Information about gisvec and cartacq.</p>
      </div>
    </div>
  );
}

